<template>
  <div class="page">
    <template v-if="category == -1">
      <p>{{ title }}</p>
      <card-box-panel
        :condition="condition"
        @category="handleCategory"
      ></card-box-panel>
      <proceed-button
        :placeholder="buttonPlaceholder"
        :disabled="!buttonPlaceholder"
        @proceed="handleProceedLocation"
      ></proceed-button>
    </template>
    <template v-else>
      <p>
        {{ title }} for <b>{{ categoryName }}</b>
      </p>
      <card-rect-panel
        :condition="condition"
        @location="handleLocation"
        :category="category"
      ></card-rect-panel>
      <proceed-button
        @proceed="openModalBooking"
        @back="handleBackButton"
        placeholder="Choose product"
        :disabled="data.locationId == -1"
        :cancel="true"
        :default="false"
      ></proceed-button>
    </template>
  </div>
</template>

<script>
import CardBoxPanel from "../shared/CardBoxPanel";
import CardRectPanel from "../shared/CardRectPanel";
import ProceedButton from "../shared/ProceedButton";
import { generatePlaceholder, generateTitle } from "../helpers/placeholder";

export default {
  name: "input-container",
  components: {
    CardBoxPanel,
    CardRectPanel,
    ProceedButton
  },
  props: {
    collection: {
      type: [String],
      default: null
    },
    category: {
      type: [Number],
      default: -1
    },
    categoryName: {
      type: [String],
      default: ""
    }
  },
  data: () => ({
    title: null,
    placeholder: null,
    buttonPlaceholder: null,
    condition: {},
    data: {
      categoryId: -1,
      locationId: -1
    }
  }),
  created() {
    this.placeholder = generatePlaceholder(this.collection); // for search input
    this.title = generateTitle(this.collection);
    this.condition = {
      collection: this.collection,
      page: 1,
      size: 10,
      action: ""
    };
  },
  methods: {
    handleCategory({ name, id }) {
      this.data.categoryId = id;
      this.buttonPlaceholder = name;
    },
    handleLocation({ id }) {
      this.data.locationId = id;
    },
    handleProceedLocation(name) {
      this.$emit("proceedLocation", { id: this.data.categoryId, name });
    },
    openModalBooking() {
      this.$emit("proceedProduct", { id: this.data.locationId });
    },
    handleBackButton() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
}
</style>
